import React from 'react'

interface ModalProps {
  open: boolean
  onClose: () => void
  children: React.ReactNode
}

export default function Modal({ open, onClose, children }: ModalProps) {
  if (!open) return null
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm animate-fade-in p-4 sm:p-8">
      <div className="bg-zinc-900 rounded-2xl shadow-2xl p-6 sm:p-8 max-w-md w-full relative animate-modal-pop max-h-[90vh] overflow-y-auto">
        <button
          className="absolute top-3 right-3 min-w-[44px] min-h-[44px] flex items-center justify-center text-zinc-400 hover:text-zinc-100 text-2xl font-bold"
          onClick={onClose}
          aria-label="Fechar"
        >
          ×
        </button>
        {children}
      </div>
      <style jsx global>{`
        @keyframes fade-in { from { opacity: 0; } to { opacity: 1; } }
        .animate-fade-in { animation: fade-in 0.2s; }
        @keyframes modal-pop { from { transform: scale(0.95); opacity: 0; } to { transform: scale(1); opacity: 1; } }
        .animate-modal-pop { animation: modal-pop 0.2s; }
      `}</style>
    </div>
  )
} 